import utils from './utils';
const API_V2 = `${BASE_API_URL}/v2/education/manager`;
export default {
  getGroups: () => utils.get(`${API_V2}/groups/`),
  getLessons: (uuid) => utils.get(`${API_V2}/lessons/?group_uuid=${uuid}`),
  appendTeacher: (uuid, teacherID) => utils.patch(`${API_V2}/lessons/${uuid}/`, {teacher: teacherID}),
  getTeachersList: () => utils.get(`${API_V2}/teachers/`),
  editGroup: (groupID, data) => utils.patch(`${API_V2}/groups/${groupID}/`, data),
  getGroup: groupID => utils.get(`${API_V2}/groups/${groupID}/`),
  getStudentsList: () => utils.get(`${API_V2}/students/`),
  getStudentsPagination: (page) => utils.get(`${API_V2}/students/?page=${page}`),
  getStudentsListFilter: (filter, options) =>
    utils.get(`${API_V2}/students/?user=${encodeURIComponent(filter)}`, null, options),
  getStudentByID: (studentID) => utils.get(`${API_V2}/students/?id=${studentID}`),
  getLesson: (lessonID, studentId) => utils.get(`${API_V2}/lessons/${lessonID}/${studentId ? `?student_pk=${studentId}` : ''}`),
  getStudentInfo: (studentID) => utils.get(`${API_V2}/students/${studentID}/`),
  getStudentsInfoList: (lessonID) => utils.get(`${API_V2}/lessons/${lessonID}/students/`),
  getStartChanges: (lessonID) => utils.get(`${API_V2}/lessons/${lessonID}/change_start/`),
  editStartChanges: (lessonID, data) => utils.post(`${API_V2}/lessons/${lessonID}/change_start/`, data),
  getRecords: () => utils.get(`${API_V2}/records/`),
  getRecordsPagination: (page) => utils.get(`${API_V2}/records/?page=${page}`),
  getLanguagesList: ()=> utils.get(`${BASE_API_URL}/languages/`),
  getStudentsListByFilter: (filterData, page)=> utils.get(`${API_V2}/students/${filterData}${page ? `&page=${page}`: ''}`),
  getCourses: ()=> utils.get(`${API_V2}/courses/`),
  getCourseById: (id)=> utils.get(`${API_V2}/courses/${id}`),
  getModules: courseID => utils.get(`${API_V2}/courses/${courseID}/modules/`),
  // апи формирования курсов
  getStrategiesList: ()=> utils.get(`${API_V2}/courses/open_strategies/`),
  createCourse: (data)=> utils.post(`${API_V2}/courses_formation/`, data),
  // студенты с занятиями
  getStudentCoursesProgress: (params) => {
    return utils.get(`${API_V2}/student_courses_progress/`, params);
  },
}



// WEBPACK FOOTER //
// ./src/api/manager.js